const isLocal = window.location.hostname === 'localhost';

export const BASE_URL = isLocal
    ? 'http://localhost:30022'
    : process.env.REACT_APP_API_URL || '';